import React, { Component } from 'react';
import "../CSS/fonts/OpenSans-Bold.eot";
import "../CSS/fonts/OpenSans-Bold.ttf";
import "../CSS/fonts/OpenSans-Regular.eot";
import "../CSS/fonts/OpenSans-Regular.ttf";
import "../CSS/fonts/OpenSans-Semibold.eot";
import "../CSS/fonts/OpenSans-Semibold.ttf";
import "../CSS/CustomStyles.css";
import { GetResources, updateUrlParameter } from "../scripts/ResourceManager.js";
import { HeaderFooter } from "./HeaderFooter";
import moment from "moment";
import { AppInsights } from "applicationinsights-js";

export class VersionData extends Component {
    constructor(props) {
        super(props);
        this.CheckFileExits = this.CheckFileExits.bind(this);
    }

    CheckFileExits(fileName, url) {
        AppInsights.trackMetric(url, 1);
        fetch('api/Home/CheckBlobExists?blobName=' + fileName)
            .then(response => response.json())
            .then(exists => {
                if (exists) {                
                    const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
                    var link = document.createElement("a");                    
                    link.href = url;                    
                    if (isIE) {
                        link.target = '_blank';
                        link.download = fileName;
                    }
                    else {
                        link.download = fileName;
                    }
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    //delete link;
                }
            }).catch((error) => {
                console.log(error);
                alert("File could not be found");
            });
    }

    render() {
        const versionInfo = this.props.data;
        const resources = this.props.resources;
        const versionIndex = this.props.versionIndex;
        const versionsCount = this.props.dataLength;
        const expState = this.props.expandState;
        const lastVersion = versionsCount - 1;
        const mobData = JSON.parse(this.props.mobileData);

        var showHidelink = null;
        if (versionIndex == 0 && versionsCount > 1) {
            var linkText = expState ? resources.hidePreviousVersions : resources.viewPreviousVersions;
            showHidelink = (<div className={"CA-PreviousVersion row mx-0 col-lg-12 px-0"}>
                <a href="javascript:void(0)" className={"CA-linkBlue font-weight-bold d-block text-left col-lg-12 pl-0"} onClick={this.props.expandCollapseClick} dangerouslySetInnerHTML={{ __html: linkText }} aria-expanded="false"></a>
            </div>);
        }

        if (versionIndex == lastVersion && versionsCount > 1) {
            var linkText = resources.hidePreviousVersions;
            showHidelink = (<div className={"CA-PreviousVersion row mx-0 col-lg-12 px-0"}>
                <a href="javascript:void(1)" className={"CA-linkBlue font-weight-bold d-block text-left col-lg-12 pl-0"} onClick={this.props.expandCollapseClick} dangerouslySetInnerHTML={{ __html: linkText }} aria-expanded="true"></a>
            </div>);
        }

        var MobileDownloads = versionIndex == 0 && mobData.length > 0 ? (<div className={"CA-downloadSection-mobile pt-2"}>
            <span className={"CA-boldHeading1"}>{resources.getOnMobileDevices}</span>
            <ul className={"row mx-0 px-0 pt-1"}>
                {mobData.map((data) => <li className={data.appType == "Apple" ? "appleStorebtn" : "googlebtn"}><a href={data.appURL} target="_blank">{data.appType}</a></li>)}
            </ul>
        </div>) : null;

        var versionValue = versionIndex == 0 ? (resources.latestVerion + " " + versionInfo.version) : (resources.oldVersion + " " + versionInfo.version);

        return (
            <div className="container-fluid pl-2 pr-0">
                <div className={"col-lg-4 col-s-12 pl-0"}>
                    <h2 className="font-14 noMargin"><span className={"CA-LatestVersion d-block pb-1"} dangerouslySetInnerHTML={{ __html: versionValue }}></span></h2>
                    <span>{versionInfo.publishedDate}</span>
                    <div className={"pt-3 CA-downloadSection"}>
                        <h3 className="short-font noMargin"><span className={"CA-boldHeading1"}>{resources.forDesktop}</span></h3>
                        <ul className={"mx-0 px-0 CA-downloadLinks pt-2"}>
                            {versionInfo[resources.downloadFileInfo].map((download, index) => ((this.props.isPreview && download.fileName) || download.fileUrl != "") ?
                                <li key={index}>
                                    <a href="javascript:void(1)" onClick={this.CheckFileExits.bind(this, download.fileName, download.fileUrl)}>
                                        <span className={"CA-desktopIcon"}></span>
                                        <span className={"textEllipsis"} dangerouslySetInnerHTML={{ __html: download[resources.fileLinkDesc] }}></span>
                                    </a>
                                </li> : null
                            )}
                        </ul>
                        {MobileDownloads}
                    </div>
                </div>
                <div className={"col-lg-8 col-s-12 pl-0 CA-FeaturesSection"} dangerouslySetInnerHTML={{ __html: versionInfo[resources.versionDesc] }}>
                </div>
                {showHidelink}
            </div>
        );
    }
}

class CleverantDownloads extends Component {
    constructor(props) {
        super(props);
        this.state = { expandedState: false };
        this.ExpandCollapseRecords = this.ExpandCollapseRecords.bind(this);
        this.FormatPublishedDates = this.FormatPublishedDates.bind(this);
    }

    ExpandCollapseRecords() {
        var newExpandedState = this.state.expandedState ? false : true;
        this.setState({ expandedState: newExpandedState });
    }

    FormatPublishedDates(dataArray) {
        dataArray.map((data) => {
            if (!isNaN(data.publishedDate)) {                 
                data.publishedDate = moment.unix(data.publishedDate / 1000).format('YYYY-MM-DD');
            }
        });
    }

    render() {        
        this.FormatPublishedDates(this.props.allDownloads.versionData);
        var formattedVersions = this.props.allDownloads.versionData.filter((ver) => { return ver.published });
        formattedVersions.sort(function (a, b) { return (moment(b.publishedDate, "YYYY-MM-DD").toDate() - moment(a.publishedDate, "YYYY-MM-DD").toDate()); });
        const versiondata = formattedVersions;
        const mobileData = this.props.allDownloads.mobileDownloads;
        const resources = this.props.resources;
        const previousVersionsSecClassNames = this.state.expandedState ? "CA-PreviousVersionSection" : "CA-PreviousVersionSection hideClass";
        var latestVersionHtml = null;
        if (versiondata.length > 0) {
            latestVersionHtml = (<div className={"CA-currentVersionSection row mx-0 p-3 bg-white"}><VersionData data={versiondata[0]} resources={resources} versionIndex={0} dataLength={versiondata.length} expandCollapseClick={this.ExpandCollapseRecords} expandState={this.state.expandedState} mobileData={mobileData} isPreview={false} /></div>);
        }
        return (
            <div>
                {latestVersionHtml}
                <div className={previousVersionsSecClassNames}>
                    {versiondata.map((version, index) => index > 0 ? <div className={"CA-DataSection row mx-0 p-3 pt-1 bg-white"}><VersionData data={version} resources={resources} versionIndex={index} dataLength={versiondata.length} expandCollapseClick={this.ExpandCollapseRecords} expandState={this.state.expandedState} mobileData={mobileData} isPreview={false} /></div> : null)}
                </div>
            </div>
        );
    }
}

export class Home extends Component {
    displayName = Home.name
    constructor(props) {
        super(props);
        this.state = {
            downloadData: {}, loading: true, resources: GetResources()
        };
        this.ToggleLanguage = this.ToggleLanguage.bind(this);

        fetch('api/Home/FetchDownloadInfo')
            .then(response => response.json())
            .then(data => {
                AppInsights.downloadAndSetup({ instrumentationKey: data.instKey });
                this.setState({ downloadData: data, loading: false });
            });
    }

    ToggleLanguage() {
        console.log("in fn")
        var newLangKey = this.state.resources.langKey == "EN" ? "FR" : "EN";
        if (window.history.pushState) {
            var newurl = updateUrlParameter(window.location.href, "lang", newLangKey);
            window.history.pushState({ path: newurl }, "", newurl);
        }
        this.setState({ resources: GetResources(newLangKey) });
        document.getElementsByTagName("html")[0].lang = newLangKey.toLowerCase();
    }



    render() {
        return (
            <HeaderFooter langResources={this.state.resources} langToggleClick={this.ToggleLanguage} hasLangToggle={true}>
                {this.state.loading ? <div className="CA-container"><div className={"CA-middleSection-Image bg-dark p-3 px-5 row mx-0 m-auto"}>
                </div><p><em>Loading...</em></p></div> : <div className="CA-container"><div className={"CA-middleSection-Image bg-dark p-3 px-5 row mx-0 m-auto"}>
                </div><div className={"CA-VersionData mx-5 mt-2 mb-2 border-dark"}><CleverantDownloads allDownloads={this.state.downloadData} resources={this.state.resources} /></div></div>}
            </HeaderFooter>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home.js